import { HostListener, inject, Input } from '@angular/core';
import { Events, IEvent } from '@df/core/service/event';

export interface IClickEvent extends IEvent {}

export interface IClickEventValue {
    data: any;
    event: MouseEvent;
}

/**
 * Abstract class for click directives containing basic methods shared everywhere.
 *
 * ```typescript
 * @Directive({
 *   selector: '[clickEvent]',
 * })
 * export class ClickEventDirective extends ClickEventAbstract {
 *   @Input('clickEvent') name: any;
 * }
 * ```
 */
import { Directive } from '@angular/core';
@Directive()
export abstract class ClickEventAbstract implements IClickEvent {
    /**
     * Event name to broadcast.
     *
     * @type {string}
     * @memberof ClickEventAbstract
     */
    abstract name: string;

    /**
     * Data to broadcast.
     *
     * @type {*}
     * @memberof ClickEventAbstract
     */
    @Input() data?: any;

    private readonly events = inject(Events);

    /**
     * Listen the clicks.
     *
     * @param {Event} event
     * @memberof ClickEventAbstract
     */
    @HostListener('click', ['$event'])
    onClick(event: MouseEvent) {
        const data = this.data;
        this.events.broadcast<IClickEventValue>(this.name, { data, event });
        // response { data: ..., event: ...}
    }
}
